<template>
  <div id="app">
    <header class="app-header">
      <div class="app-header__brand">
        <img src="./assets/logo/byyl-logo1.png" class="logoImg"/>
      </div>
      <div v-if="isLogin" class="app-header__user">
        <div class="navDiv">
          <img src="./assets/images/antOutline-bell.svg" class="messageImg">
        </div>
        <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
          <div>
            <img :src="avatarFilePath" class="profileImg">
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item divided @click.native="logout">
              <span>退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <span class="profileSpan">用户名：{{user.userName}}</span>
      </div>
    </header>
    <main class="app-main">
      <router-view/>
    </main>
  </div>
</template>

<script>
  import Cookies from "js-cookie";
  import {getInfo} from '@/api/login';
  export default {
    name: 'App',
    data() {
      return {
        isLogin: false,
        offsetVale: 8,
        username:'',
        avatarFilePath:'',
        user:{}
      };
    },
    methods: {
      async logout() {
        this.$confirm('确定注销并退出系统吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.removeToken();
          sessionStorage.clear();
          location.href = '/';
        })
      },
      ConnMQTTServer(){
          // mqtttx cpuid luhongjun订阅主题   byyl用户名   密码Byyl2022#    "0" 不加日志  生产环境   1-7 加日志   ProcessMQTTMessages回调消息的名称
          let result = window.ConnMQTT("tcp://139.210.5.110:1883","mqttx_13756305180","luhongjun","byyl","Byyl2022#","0","ProcessMQTTMessages",function (result) {
          let state=result.substr(0,1);            //状态，0-错误，1-正雀，2-错误
          let CookieValue=result.substr(2);        //错误
          console.log(CookieValue);
          console.log("创建连接和默认topic订阅---->"+result);
        });
      }
    },
    mounted() {
      const adminToken = this.getToken();
      const user = this.getDataFromCookie("user");
      console.log('admin-doctor-token='+adminToken);
      console.log(user,"user");
      if(adminToken){
        this.isLogin = true;
        // 获得用户信息
        getInfo().then(response=>{
          console.log("主页-获得用户信息");
          console.log(response);
          if(response.code==0){
            this.user = response.data;
            // 头像  response.data.avatarFilePath
            let filePath = this.downloadServer+response.data.avatarFilePath;
            console.log(require("@/assets/images/profile.png"),'profile')
            this.avatarFilePath = response.data.avatarFilePath?filePath:require("@/assets/images/profile.png");
          }
        });
      }else{
        this.isLogin = false;
      }
    },
    created() {
      // 创建连接和默认topic订阅  处理卡死异常
      // this.ConnMQTTServer();
    }
  }
</script>

<style>
  .right-menu-item {
    display: inline-block;
    padding: 0;
    height: 100%;
    font-size: 18px;
    color: #5a5e66;
    vertical-align: middle;
  }
  .hover-effect {
    cursor: pointer;
    transition: opacity .2s;
  }
  .hover-effect:hover {
    opacity: 0.85;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue